import {articleSelectionType} from '@strapi/types/ArticleMainInfo';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

export const useSwiperSlideAnalytics = () => {
  const logCompilationSwipe = (
    selection: articleSelectionType,
    selectionNumber: number,
  ) => {
    return (direction: 'left' | 'right') => {
      logTmrEvent(`article.swipe${direction === 'right' ? 'Right' : 'Left'}`, {
        compilation_id: selection?.id,
        compilation_name: selection.title,
        compilation_num: selectionNumber,
      });
    };
  };
  return {logCompilationSwipe};
};
